if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.dragState = null;

        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.target.closest('[data-product-zoom-controls], .product-media-modal__content')) {
              this.endDrag(event);
              event.stopImmediatePropagation();
            }
          },
          true
        );

        this.addEventListener('click', (event) => {
          const zoomControl = event.target.closest('[data-product-zoom-action]');
          if (!zoomControl) return;

          event.preventDefault();
          const currentLevel = Number(this.dataset.zoomLevel) || 2;
          const direction = zoomControl.dataset.productZoomAction === 'in' ? 0.25 : -0.25;
          this.setZoomLevel(currentLevel + direction);
        });

        this.addEventListener('pointerdown', (event) => this.startDrag(event));
        this.addEventListener('pointermove', (event) => this.moveDrag(event));
        this.addEventListener('pointerup', (event) => this.endDrag(event));
        this.addEventListener('pointercancel', (event) => this.endDrag(event));
        this.addEventListener('dragstart', (event) => {
          if (event.target.closest('.product-media-modal__content img.active')) event.preventDefault();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // Shopify's embedded editor already owns the preview scroll surface.
        // Opening the storefront zoom modal inside that iframe creates nested
        // scroll owners, so keep zoom exclusive to real storefront previews.
        if (
          window.Shopify?.designMode ||
          document.documentElement.classList.contains('shopify-design-mode')
        )
          return;

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const zoomControls = this.querySelector('[data-product-zoom-controls]');
        const canZoom = !isMobile && activeMedia.nodeName === 'IMG';

        if (zoomControls) zoomControls.hidden = !canZoom;

        if (isMobile && activeMedia.nodeName === 'IMG') {
          activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          requestAnimationFrame(() => {
            const activeMediaRect = activeMedia.getBoundingClientRect();
            container.scrollLeft = Math.max(0, (activeMediaRect.width - container.clientWidth) / 2);
            container.scrollTop = Math.max(0, (activeMediaRect.height - container.clientHeight) / 2);
          });
        } else if (canZoom) {
          this.setZoomLevel(2);
        } else {
          this.dataset.zoomLevel = '1';
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setZoomLevel(level) {
        const zoomLevel = Math.min(2, Math.max(1, Math.round(level * 4) / 4));
        const container = this.querySelector('[role="document"]');
        const zoomOut = this.querySelector('[data-product-zoom-action="out"]');
        const zoomIn = this.querySelector('[data-product-zoom-action="in"]');
        const zoomValue = this.querySelector('[data-product-zoom-value]');

        this.dataset.zoomLevel = String(zoomLevel);
        if (zoomOut) zoomOut.disabled = zoomLevel <= 1;
        if (zoomIn) zoomIn.disabled = zoomLevel >= 2;
        if (zoomValue) zoomValue.textContent = `${Math.round(zoomLevel * 100)}%`;

        requestAnimationFrame(() => {
          container.scrollLeft = Math.max(0, (container.scrollWidth - container.clientWidth) / 2);
          container.scrollTop = Math.max(0, (container.scrollHeight - container.clientHeight) / 2);
        });
      }

      startDrag(event) {
        if (
          event.button !== 0 ||
          window.matchMedia('(max-width: 749px)').matches ||
          Number(this.dataset.zoomLevel) <= 1 ||
          !event.target.closest('.product-media-modal__content img.active')
        )
          return;

        const container = this.querySelector('[role="document"]');
        this.dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          scrollLeft: container.scrollLeft,
          scrollTop: container.scrollTop,
          captureTarget: event.target,
        };

        event.preventDefault();
        event.target.setPointerCapture(event.pointerId);
        this.classList.add('is-dragging');
      }

      moveDrag(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

        const container = this.querySelector('[role="document"]');
        event.preventDefault();
        container.scrollLeft = this.dragState.scrollLeft - (event.clientX - this.dragState.startX);
        container.scrollTop = this.dragState.scrollTop - (event.clientY - this.dragState.startY);
      }

      endDrag(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

        if (this.dragState.captureTarget.hasPointerCapture(event.pointerId)) {
          this.dragState.captureTarget.releasePointerCapture(event.pointerId);
        }
        this.dragState = null;
        this.classList.remove('is-dragging');
      }
    }
  );
}
